import { debounce } from "es-toolkit";
import { useEffect, useMemo } from "react";

import type { Point } from "../types";
import { usePan } from "./PanContext";
import { useZoom } from "./ZoomContext";

type Props = {
  onChange: (perspective: { zoom: number; pan: Point }) => void;
  children: React.ReactNode;
};

export const PerspectiveListener = ({ onChange, children }: Props) => {
  const { zoom } = useZoom();
  const { pan } = usePan();

  const debouncedCallback = useMemo(
    () => debounce((newZoom: number, newPan: Point) => onChange({ zoom: newZoom, pan: newPan }), 100),
    [onChange],
  );

  useEffect(() => {
    debouncedCallback(zoom, pan);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return debouncedCallback.cancel;
  }, [zoom, pan, debouncedCallback]);

  return <>{children}</>;
};
